import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import FlashTicker from "@/pages/home/components/FlashTicker";
import FeedSection from "@/pages/home/components/FeedSection";
import ReviewsSection from "@/pages/home/components/ReviewsSection";
import TopicsSection from "@/pages/home/components/TopicsSection";
import NewsletterSection from "@/pages/home/components/NewsletterSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FlashTicker />
        <FeedSection />
        <ReviewsSection />
        <TopicsSection />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
}